import { render, staticRenderFns } from "./SelectStep.vue?vue&type=template&id=5d528809&scoped=true"
import script from "./SelectStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectStep.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectStep.vue?vue&type=style&index=0&id=5d528809&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d528809",
  null
  
)

export default component.exports